<template>
  <img :src="imgSrc" :alt="alt">
</template>

<script>
  export default {
    name: 'webp-image',
    props: {
      src: {
        type: String,
        default: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      },
      alt: {
        type: String,
        default: ''
      }
    },
    computed: {
      imgSrc () {
        const imageSrc = this.http2https(this.src)
        const separator = /\.\w{3,4}\?/.test(imageSrc) ? '&' : '?'
        return window.supportWebp ? `${imageSrc}${separator}imageMogr2/format/webp` : imageSrc
      }
    },
    methods: {
      http2https (link) {
        return link.replace('http://', 'https://')
          .replace('cdn.llsapp.com', 'cdn.llscdn.com') // for 老用户头像地址
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/WebpImage.vue